import { useAct } from 'FlowBuilder/store'
import CodeMirrorEditor from 'Shared/components/CodeMirrorEditor'
import JsonField from './JsonField'
import CheckboxField from 'Shared/components/CheckboxField'

const Form = () => {
  const act = useAct()

  const {
    id,
    name,
    description,
    bodyHtml,
    headHtml,
    stylesCss,
    fields,
    inUse,
    enabledForNewPages,
    systemTemplate,
    additionalHead,
    additionalCss
  } = useSel((s) => s.builder.flowTemplate)

  const remove = () => {
    if (inUse) {
      return Promise.resolve()
    }
    if (confirm('Are you sure?')) {
      act.flowTemplate.remove(id).then(() => (window.location.href = '/admin/settings/flow_templates'))
    }
  }

  return (
    <>
      <div className="section">
        <div className="box">
          <div className="input_container_name">
            <label className="margin-bottom half">Name</label>
            <input type='text' name='name' value={name} onChange={(e) => act.builder.upsertFlowTemplate({name: e.target.value})} disabled={systemTemplate} />
            {!name && (
              <p className="error">Name is required</p>
            )}
          </div>

          <div className="input_container_description margin-top">
            <label className="margin-bottom half">Description</label>
            <input type='text' name='description' value={description || ''} onChange={(e) => act.builder.upsertFlowTemplate({description: e.target.value})} disabled={systemTemplate} />
          </div>

          <div className="input_container_enabled_for_new_pages margin-top">
            <CheckboxField label='Enabled for new pages' value={enabledForNewPages} onChange={(value) => act.builder.upsertFlowTemplate({enabledForNewPages: value})} />
          </div>

          { systemTemplate &&
            <>
              <p>You can't edit the HTML or CSS for this template as it's a template managed by Movement, but you can use the <b>Additional Head HTML</b> and <b>Additional CSS</b> fields below to include additional JavaScript, tags, or CSS. For complete customisation, please clone this template.</p>

              <div className="input_container_additional_head_html margin-top">
                <label className="margin-bottom half">Additional Head HTML</label>
                <CodeMirrorEditor
                  value={additionalHead || ''}
                  onChange={(val) => act.builder.upsertFlowTemplate({additionalHead: val})}
                  mode='html'
                />
              </div>

              <div className="input_container_additional_styles_css margin-top">
                <label className="margin-bottom half">Additional CSS</label>
                <CodeMirrorEditor
                  value={additionalCss || ''}
                  onChange={(val) => act.builder.upsertFlowTemplate({additionalCss: val})}
                  mode='css'
                />
              </div>
            </>
          }
          { !systemTemplate && <>
            <div className="input_container_body_html margin-top">
              <label className="margin-bottom half">Body HTML</label>
              <CodeMirrorEditor
                value={bodyHtml || ''}
                onChange={(val) => act.builder.upsertFlowTemplate({bodyHtml: val})}
                mode='html'
              />
            </div>

            <div className="input_container_head_html margin-top">
              <label className="margin-bottom half">Head HTML</label>
              <CodeMirrorEditor
                value={headHtml || ''}
                onChange={(val) => act.builder.upsertFlowTemplate({headHtml: val})}
                mode='html'
              />
            </div>

            <div className="input_container_styles_css margin-top">
              <label className="margin-bottom half">Styles CSS</label>
              <CodeMirrorEditor
                value={stylesCss || ''}
                onChange={(val) => act.builder.upsertFlowTemplate({stylesCss: val})}
                mode='css'
              />
            </div>

            <div className="input_container_fields margin-top">
              <JsonField
                name="Fields"
                value={fields || ''}
                onChange={(val) => act.builder.upsertFlowTemplate({fields: val})}
              />
            </div>

            <div className="box danger-zone margin-top">
              <h3 className="no-margin-top red">Danger zone</h3>
              { inUse ? (
                <p className="smaller dark-grey no-margin-top">You can't delete this page template as it's currently in use.</p>
              ) : (
                <p className="smaller dark-grey no-margin-top">If you delete this page template, it'll no longer be usable in pages.</p>
              )}
              <button className="button red" onClick={remove} disabled={inUse}>Delete</button>
            </div>
          </> }
        </div>
      </div>
    </>
  )
}

export default Form
